const adminPrefix = '/admin/announcements';
const publicPrefix = '/announcements';

const AnnouncementApiRoutes = {
  // Admin routes
  List: adminPrefix,
  Create: adminPrefix,
  Show: adminPrefix + '/{id}',
  Update: adminPrefix + '/{id}',
  Delete: adminPrefix + '/{id}',
  Publish: adminPrefix + '/{id}/publish',
  CancelSchedule: adminPrefix + '/{id}/cancel-schedule',
  Generate: adminPrefix + '/generate',
  GenerateAll: adminPrefix + '/generate-all',
  UploadImage: adminPrefix + '/upload-image',
  Stats: adminPrefix + '/{id}/stats',
  GlobalStats: adminPrefix + '/stats',

  // Authenticated routes (in-app popup)
  Pending: publicPrefix + '/pending',
  History: publicPrefix + '/history',
  Interaction: publicPrefix + '/{id}/interaction',
};

export default AnnouncementApiRoutes;
